import type { ReactNode } from 'react';
import { useEffect, useRef } from 'react';

/// A native <dialog>, so focus trapping and Escape come from the platform
/// rather than being reimplemented.
export function Dialog({ title, onClose, children }: {
  title: string;
  onClose: () => void;
  children: ReactNode;
}) {
  const ref = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const element = ref.current;
    element?.showModal();
    return () => element?.close();
  }, []);

  return (
    <dialog ref={ref} onClose={onClose} className="dialog">
      <h2>{title}</h2>
      {children}
    </dialog>
  );
}
